import { ProductComparisonData, ProductModel, BaseFeature } from "./types";

// ویژگی‌های پایه برای دستبندهای هوشمند
const smartBandBaseFeatures: BaseFeature[] = [
    // {
    //     feature: "ظرفیت باتری (mAh)",
    //     description: "ظرفیت باتری به میلی‌آمپر ساعت برای مدت زمان استفاده مداوم",
    // },
    {
        feature: "عمر باتری",
        description: "مدت زمان نگهداری شارژ در استفاده عادی",
    },
    {
        feature: "زمان آماده‌باش",
        description: "مدت زمان نگهداری شارژ در حالت آماده‌باش",
    },
    {
        feature: "نوع شارژ",
        description: "روش اتصال شارژر به دستگاه",
    },
    {
        feature: "گواهی ضد آب",
        description: "استاندارد مقاومت در برابر نفوذ آب",
    },
    {
        feature: "جنس بدنه",
        description: "متریال ضدحساسیت و مقاوم",
    },
    {
        feature: "جنس بند",
        description: "نوع متریال بند دستگاه",
    },
    {
        feature: "نمایشگر",
        description: "نوع و اندازه صفحه نمایش",
    },

    // {
    //     feature: "بلوتوث",
    //     description: "نسخه بلوتوث برای اتصال",
    // },

    {
        feature: "پایش خواب",
        description: "تحلیل کیفیت خواب شبانه",
    },
    {
        feature: "ضربان قلب",
        description: "پایش مداوم سلامت قلب",
    },
    {
        feature: "تغییرات HRV",
        description: "بررسی تغییرات زمانی بین ضربان‌های قلب",
    },
    {
        feature: "ECG (نوار قلب)",
        description: "تشخیص بی‌نظمی‌های قلب",
    },
    {
        feature: "سطح اکسیژن خون (SpO2)",
        description: "بررسی سطح اکسیژن در خون",
    },
    {
        feature: "روند انرژی و متابولیسم",
        description: "پایش و ارزیابی غیرتهاجمی شاخص‌های انرژی",
    },
    {
        feature: "VO2max",
        description: "سنجش توان هوازی بدن",
    },
    {
        feature: "بانوان",
        description: "پایش چرخه قاعدگی، تخمک‌گذاری و سلامت بانوان",
    },
    {
        feature: "دمای پوست",
        description: "پایش تغییرات دمای بدن",
    },
    {
        feature: "سطح استرس",
        description: "ارزیابی تنش روزانه",
    },
    {
        feature: "پایش گردش خون",
        description: "ارزیابی و تخمین روند گردش خون",
    },
    {
        feature: "تعداد حالت‌های ورزشی",
        description: "شمار انواع فعالیت‌های ورزشی قابل پایش",
    },
    // {
    //     feature: "مقاومت آب",
    //     description: "سطح مقاومت در برابر آب",
    // },
    // {
    //     feature: "به‌روزرسانی OTA",
    //     description: "امکان به‌روزرسانی نرم‌افزار از راه دور",
    // },
    {
        feature: "رنگ‌بندی",
        description: "رنگ‌های متنوع و قابل انتخاب",
    },
    {
        feature: "پایش سلامت پیوسته و ۲۴ ساعته",
        description: "رصد دائمی علائم حیاتی در طول شبانه‌روز",
    },
    {
        feature: "اشتراک‌گذاری سلامت با خانواده و اعضا",
        description: "امکان ارسال وضعیت سلامت به عزیزان",
    },
];

// محصولات دسته دستبند هوشمند
const smartBands: ProductModel[] = [
    {
        id: "EVB-E50",
        title: "EVB-E50",
        icon: "/media/hero-band/band3.webp",
        colorClass: "from-emerald-500 to-teal-700",
        category: "screenless-band",
        features: [
            { feature: "وزن", value: "فوق‌العاده سبک و کم‌حجم (طراحی ارگونومیک بدون صفحه نمایش)" },
            { feature: "جنس بدنه", value: "آلیاژ روی و پلی‌کربنات فشرده (Zinc Alloy + PC)" },
            { feature: "جنس بند", value: "پارچه‌ای بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت" },
            { feature: "رنگ‌بندی", value: "مشکی، طوسی، سرمه‌ای و رنگ‌های متنوع" },
            { feature: "گواهی ضد آب", value: "IP68 (مقاوم در برابر آب، تعریق و فعالیت‌های روزانه)" },
            { feature: "درجه دقت حسگرها", value: "دقت بالا مجهز به الکترودهای ECG و سنسور اپتیکال دوگانه PPG" },
            { feature: "ظرفیت باتری (mAh)", value: "130 mAh (لیتیوم پلیمری کم‌مصرف)" },
            { feature: "عمر باتری", value: "7 تا 14 روز (شارژدهی طولانی به دلیل حذف نمایشگر)" },
            { feature: "زمان آماده‌باش", value: "30+ روز" },
            { feature: "نوع شارژ", value: "مگنتیک مغناطیسی (Magnetic Fast Charge)" },
            { feature: "نمایشگر", value: "بدون نمایشگر (Faceless / Screenless با نشانگر وضعیت LED)" },
            { feature: "بلوتوث", value: "BLE 5.0" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: "ارزیابی غیرتهاجمی روند انرژی" },
            { feature: "پایش خواب", value: "پایش خودکار و پیشرفته مراحل خواب، کیفیت استراحت و تنفس" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "پایش گردش خون", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: "پایش ۲۴ ساعته سطح استرس و تحلیل تعادل عصبی با HRV" },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (پایش چرخه قاعدگی و سلامت بانوان)" },
            { feature: "تعداد حالت‌های ورزشی", value: "مودهای چندگانه ورزشی (Multi-Sport)، سنجش کالری و مسافت" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-1s",
        title: "EVB-1s",
        icon: "/media/hero-band/EVB-1s.webp",
        colorClass: "from-purple-500 to-indigo-600",
        category: "screenless-band",
        features: [
            { feature: "وزن", value: "فوق‌العاده سبک و ارگونومیک (ابعاد 42×22×9.5 میلی‌متر)" },
            { feature: "جنس بدنه", value: "پلی‌کربنات مقاوم و آلیاژ سبک (PC+ABS)" },
            { feature: "جنس بند", value: "بافت‌دار کشسان و تنفسی (Woven) / نایلونی ضدحساسیت" },
            { feature: "رنگ‌بندی", value: "مشکی، زیتونی، رنگ‌های متنوع و جذاب" },
            { feature: "گواهی ضد آب", value: "IP68 (مقاوم در برابر آب و غوطه‌وری)" },
            { feature: "درجه دقت حسگرها", value: "پیشرفته با الگوریتم‌های هوش مصنوعی ریکاوری و سنسورهای چندگانه" },
            { feature: "ظرفیت باتری (mAh)", value: "95 mAh (لیتیوم پلیمری کم‌مصرف)" },
            { feature: "عمر باتری", value: "7 تا 10 روز" },
            { feature: "زمان آماده‌باش", value: "25+ روز" },
            { feature: "نوع شارژ", value: "مگنتیک فست‌شارژ (Magnetic Fast Charge)" },
            { feature: "نمایشگر", value: "بدون نمایشگر (Screenless - تمرکز کامل بر ریکاوری بدون حواس‌پرتی)" },
            { feature: "بلوتوث", value: "BLE 5.0 (برد تا ۱۰ متر)" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: true },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: "پایش پیشرفته فازهای خواب (REM/عمیق/سبک)، ریتم تنفسی و نمره خواب" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "پایش گردش خون", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: "ارزیابی استرس و پایش حالات روحی مبتنی بر هوش مصنوعی (AI Mood)" },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (پایش چرخه قاعدگی و پیش‌بینی تخمک‌گذاری)" },
            { feature: "تعداد حالت‌های ورزشی", value: "پایش بار تمرینی (Strain)، ریکاوری هوشمند و مربی هوش مصنوعی" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-V10",
        title: "EVB-V10",
        icon: "/media/hero-band/band4.webp",
        colorClass: "from-blue-500 to-indigo-600",
        category: "screenless-band",
        features: [
            { feature: "وزن", value: "فوق‌العاده سبک (ابعاد 25.5×9.3×4.35 میلی‌متر)" },
            { feature: "جنس بدنه", value: "استیل ضدزنگ (Stainless Steel)" },
            { feature: "جنس بند", value: "بافت‌دار تنفسی (Woven) / سیلیکونی ضدحساسیت" },
            { feature: "رنگ‌بندی", value: "مشکی، نقره‌ای، رنگ‌های متنوع" },
            { feature: "گواهی ضد آب", value: "3ATM (مقاوم تا عمق ۳۰ متری)" },
            { feature: "درجه دقت حسگرها", value: "پیشرفته با هوش مصنوعی و سنسورهای اپتیکال چندگانه" },
            { feature: "ظرفیت باتری (mAh)", value: "23 mAh (بهینه‌سازی شده با مصرف فوق‌العاده کم)" },
            { feature: "عمر باتری", value: "7+ روز" },
            { feature: "زمان آماده‌باش", value: "20+ روز" },
            { feature: "نوع شارژ", value: "مگنتیک فست‌شارژ (کمتر از ۱.۵ ساعت)" },
            { feature: "نمایشگر", value: "بدون نمایشگر (طراحی مینیمال و ارگونومیک)" },
            { feature: "بلوتوث", value: "5.3" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: false },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: "ارزیابی غیرتهاجمی روند انرژی با هوش مصنوعی (AI Energy)" },
            { feature: "پایش خواب", value: "پایش پیشرفته فازهای خواب (REM/عمیق) و کیفیت تنفس" },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "پایش گردش خون", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل (پایش چرخه و سلامت بانوان)" },
            { feature: "تعداد حالت‌های ورزشی", value: "پایش ۲۴ ساعته فعالیت، شدت METS و بار ورزشی" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-E90",
        title: "EVB-E90",
        icon: "/media/products/band/EVB-E90.webp",
        colorClass: "from-gray-300 to-gray-500",
        category: "screenless-band",
        features: [
            { feature: "وزن", value: "نامشخص" },
            { feature: "جنس بدنه", value: "پلی‌کربنات (PC) " },
            { feature: "جنس بند", value: "پارچه‌ای (Woven) / سیلیکونی" },
            { feature: "رنگ‌بندی", value: "مشکی (استاندارد)" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "درجه دقت حسگرها", value: "بالا (تراشه ECG با فرکانس 512Hz)" },
            { feature: "ظرفیت باتری (mAh)", value: "180 mAh" },
            { feature: "عمر باتری", value: "7 تا 15 روز" },
            { feature: "زمان آماده‌باش", value: "30+ روز" },
            { feature: "نوع شارژ", value: "مگنتیک (Magnetic)" },
            { feature: "نمایشگر", value: "بدون نمایشگر (LED Indicator)" },
            { feature: "بلوتوث", value: "5.3" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: false },
            { feature: "پایش گردش خون", value: false },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "ندارد" },
            { feature: "تعداد حالت‌های ورزشی", value: "Multi-Sport" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-X8",
        title: "EVB-X8",
        icon: "/media/products/band/EVB-X8.webp",
        colorClass: "from-teal-400 to-teal-600",
        category: "screenless-band",
        features: [
            { feature: "وزن", value: "نامشخص" },
            { feature: "جنس بدنه", value: "پلی‌کربنات (PC) " },
            { feature: "جنس بند", value: "بندهای بافت‌دار (Woven)" },
            { feature: "رنگ‌بندی", value: "رنگ‌های متنوع (Vibrant Bands)" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "درجه دقت حسگرها", value: "دقت بالا (High-Precision)" },
            { feature: "ظرفیت باتری (mAh)", value: "180 mAh" },
            { feature: "عمر باتری", value: "بیشتر از 15 روز" },
            { feature: "نوع شارژ", value: "مگنتیک (Magnetic)" },
            { feature: "نمایشگر", value: "بدون نمایشگر (LED Indicator)" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "زمان آماده‌باش", value: "30+ روز" },

            { feature: "ECG (نوار قلب)", value: true },
            { feature: "پایش گردش خون", value: true },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: false },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "NFC", value: false },
            { feature: "بانوان", value: "پشتیبانی کامل" },
            { feature: "تعداد حالت‌های ورزشی", value: "Multi-Sport" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "smart-band-2",
        title: "EVB-X5",
        icon: "/media/products/band/band-4.webp",
        rotation: 5,
        colorClass: "from-blue-200 to-blue-300",
        category: "smartband",
        features: [
            { feature: "ظرفیت باتری (mAh)", value: "58 mAh + 210 mAh dock" },
            { feature: "عمر باتری", value: "30 روز" },
            { feature: "زمان آماده‌باش", value: "45 روز" },
            { feature: "نوع شارژ", value: "Magnetic Charging Dock" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "جنس بدنه", value: "ABS+PC" },
            { feature: "جنس بند", value: "Silicone" },
            { feature: "نمایشگر", value: "بدون نمایشگر" },
            { feature: "بلوتوث", value: "5.0" },
            { feature: "حسگر ضربان قلب", value: "PPG" },
            { feature: "ضربان قلب 24/7", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "پایش گردش خون", value: true },
            { feature: "تعداد حالت‌های ورزشی", value: "Multi-Sport" },
            { feature: "مقاومت آب", value: "IP68" },
            { feature: "به‌روزرسانی OTA", value: true },
            { feature: "رنگ‌بندی", value: "Vibrant Colors" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-P11",
        title: "EVB-P11",
        icon: "/media/products/band/EVB-P11.webp",
        colorClass: "from-green-400 to-green-600",
        category: "fitness-band",
        features: [
            { feature: "وزن", value: "حدود ۲۵ گرم" },
            { feature: "جنس بند", value: "بند سیلیکونی" },
            { feature: "جنس بدنه", value: "دیجیتالی" },
            { feature: "نمایشگر", value: "دارای نمایشگر" },

            { feature: "رنگ‌بندی", value: "مشکی، آبی، قرمز، سبز" },
            { feature: "گواهی ضد آب", value: "IP67" },
            { feature: "درجه دقت حسگرها", value: "معمولی (مناسب پایش روزمره و تناسب اندام)" },
            { feature: "عمر باتری", value: "۵ تا ۷ روز (باتری 130mAh)" },
            { feature: "شارژ بی‌سیم", value: false },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "ECG (نوار قلب)", value: true },
            { feature: "VO2max", value: false },
            { feature: "روند انرژی و متابولیسم", value: false },
            { feature: "پایش خواب", value: true },
            { feature: "نرخ تنفس", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "قدم‌شمار", value: true },
            { feature: "تعداد حالت‌های ورزشی", value: "Multi-Sport" },
            { feature: "سطح استرس", value: true },
            { feature: "ژست‌های حرکتی", value: false },
            { feature: "تماس اضطراری", value: false },
            { feature: "API توسعه‌دهنده", value: false },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "smart-band-3",
        title: "EVB-s2",
        icon: "/media/products/band/band-3.webp",
        rotation: -3,
        colorClass: "from-blue-200 to-blue-300",
        category: "smartband",
        features: [
            { feature: "ظرفیت باتری (mAh)", value: "100 mAh" },
            { feature: "عمر باتری", value: "7-14 روز" },
            { feature: "زمان آماده‌باش", value: "30 روز" },
            { feature: "نوع شارژ", value: "Magnetic" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "جنس بدنه", value: "Plastic" },
            { feature: "جنس بند", value: "Silicone" },
            { feature: "نمایشگر", value: "بدون نمایشگر" },
            { feature: "بلوتوث", value: "5.0" },
            { feature: "حسگر ضربان قلب", value: "PPG با دقت بالا" },
            { feature: "ضربان قلب 24/7", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "دمای پوست", value: false },
            { feature: "سطح استرس", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "پایش گردش خون", value: false },
            { feature: "تعداد حالت‌های ورزشی", value: "Swimming/Running/Cycling/Yoga" },
            // { feature: "مقاومت آب", value: "Swimming Compatible" },
            { feature: "به‌روزرسانی OTA", value: true },
            { feature: "رنگ‌بندی", value: "Multiple Colors" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "smart-band-4",
        title: "EVB-A2",
        icon: "/media/products/band/band-2.webp",
        rotation: 8,
        colorClass: "from-blue-200 to-blue-300",
        category: "smartband",
        features: [
            { feature: "ظرفیت باتری (mAh)", value: "150 mAh" },
            { feature: "عمر باتری", value: "20-30 روز" },
            { feature: "زمان آماده‌باش", value: "45-60 روز" },
            { feature: "نوع شارژ", value: "Magnetic" },
            { feature: "گواهی ضد آب", value: "1ATM" },
            { feature: "جنس بدنه", value: "Plastic" },
            { feature: "جنس بند", value: "Silicone/Nylon" },
            { feature: "نمایشگر", value: "بدون نمایشگر" },
            { feature: "بلوتوث", value: "5.2" },
            { feature: "حسگر ضربان قلب", value: "VC30F-S" },
            { feature: "ضربان قلب 24/7", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "دمای پوست", value: false },
            { feature: "سطح استرس", value: false },
            { feature: "پایش گردش خون", value: true },
            { feature: "تعداد حالت‌های ورزشی", value: "127" },
            { feature: "مقاومت آب", value: "1ATM" },
            { feature: "به‌روزرسانی OTA", value: true },
            { feature: "رنگ‌بندی", value: "Multiple" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-5",
        title: "SmartBand-M",
        icon: "/media/products/band/band-5.webp",
        rotation: -8,
        colorClass: "from-blue-200 to-blue-300",
        category: "smartband",
        features: [
            { feature: "ظرفیت باتری (mAh)", value: "55 mAh" },
            { feature: "عمر باتری", value: "20-30 روز" },
            { feature: "زمان آماده‌باش", value: "45 روز" },
            { feature: "نوع شارژ", value: "Magnetic" },
            { feature: "گواهی ضد آب", value: "1ATM" },
            { feature: "جنس بدنه", value: "Zinc Alloy" },
            { feature: "جنس بند", value: "Steel/Silicone" },
            { feature: "نمایشگر", value: '0.72" OLED' },
            { feature: "بلوتوث", value: "5.2" },
            { feature: "حسگر ضربان قلب", value: "VC30F-S" },
            { feature: "ضربان قلب 24/7", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "دمای پوست", value: false },
            { feature: "سطح استرس", value: false },
            { feature: "پایش گردش خون", value: true },
            { feature: "تعداد حالت‌های ورزشی", value: "170+" },
            { feature: "مقاومت آب", value: "1ATM" },
            { feature: "به‌روزرسانی OTA", value: true },
            { feature: "رنگ‌بندی", value: "Multiple" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
    {
        id: "EVB-1",
        title: "SmartBand-A1",
        icon: "/media/products/band/band-1.webp",
        rotation: -5,
        colorClass: "from-blue-200 to-blue-300", // رنگ آبی برای دسته دستبند هوشمند
        category: "smartband",
        features: [
            { feature: "ظرفیت باتری (mAh)", value: "95 mAh" },
            { feature: "عمر باتری", value: "30 روز" },
            { feature: "زمان آماده‌باش", value: "45 روز" },
            { feature: "نوع شارژ", value: "Magnetic USB" },
            { feature: "گواهی ضد آب", value: "IP68" },
            { feature: "جنس بدنه", value: "ABS+PC" },
            { feature: "جنس بند", value: "Silicone" },
            { feature: "نمایشگر", value: "بدون نمایشگر" },
            { feature: "بلوتوث", value: "5.0" },
            { feature: "حسگر ضربان قلب", value: "PPG" },
            { feature: "ضربان قلب 24/7", value: true },
            { feature: "ضربان قلب", value: true },
            { feature: "سطح اکسیژن خون (SpO2)", value: true },
            { feature: "پایش خواب", value: true },
            { feature: "دمای پوست", value: true },
            { feature: "سطح استرس", value: true },
            { feature: "تغییرات HRV", value: true },
            { feature: "پایش گردش خون", value: false },
            { feature: "تعداد حالت‌های ورزشی", value: "50+" },
            { feature: "مقاومت آب", value: "IP68" },
            { feature: "به‌روزرسانی OTA", value: true },
            { feature: "رنگ‌بندی", value: "Black/Blue/Pink" },
            { feature: "پایش سلامت پیوسته و ۲۴ ساعته", value: true },
            { feature: "اشتراک‌گذاری سلامت با خانواده و اعضا", value: true },
        ],
    },
];

// ترکیب همه محصولات
const allSmartBands = [...smartBands];

// محصولات پیشرفته بر اساس مشخصات فنی (ECG، روند انرژی و متابولیسم، پایش گردش خون، هوش مصنوعی و سنسورهای سطح ممتاز)
const advancedBands: ProductModel[] = [
    smartBands.find((b) => b.id === "EVB-X8")!,
    smartBands.find((b) => b.id === "EVB-V10")!,
    smartBands.find((b) => b.id === "EVB-E50")!,
    smartBands.find((b) => b.id === "EVB-1s")!,
].filter(Boolean);

// محصولات ویژه بانوان با پشتیبانی از سلامت بانوان و پایش چرخه
const womenBands: ProductModel[] = [
    smartBands.find((b) => b.id === "EVB-V10")!,
    smartBands.find((b) => b.id === "smart-band-2")!, // EVB-X5
    smartBands.find((b) => b.id === "EVB-5")!,        // SmartBand-M
    smartBands.find((b) => b.id === "EVB-1s")!,
].filter(Boolean);

// داده‌های نهایی برای دستبندهای هوشمند
export const smartBandsData: ProductComparisonData = {
    baseFeatures: smartBandBaseFeatures,
    categories: [
        { id: "all", label: "همه", products: allSmartBands },
        { id: "advanced", label: "پیشرفته", products: advancedBands },
        { id: "women", label: "بانوان", products: womenBands },
    ],
    allProducts: allSmartBands,
};
